import React from "react";
import * as tooltips from "../../../i18n/en/help.json";
import ReactHtmlParser from "react-html-parser";

export const tooltipTubeFormat = {
  title: "Tube Format",
  content: (
    <ul className="list-unstyled">
      <li>
        Single-tube format - Primers, wild-type and mutant probes pre-mixed in a
        ready to use format.
      </li>
      <li>
        Two-tube format - Mutant and wild-type probes provided in separate
        tubes. Mutant and wild-type assays must be ordered separately and mixed
        by user.
      </li>
    </ul>
  ),
};

export const tooltipIdentifierGeneExpression = {
  title: "Target Identifier",
  content: (
    <ul className="list-unstyled">
      <li>Enter gene symbol or GenBank ID</li>
      <li>Examples:</li>
      <ul>
        <li>GAPDH</li>
        <li>2597</li>
      </ul>
    </ul>
  ),
};

// Tooltip for Mutation Detection Identifier
//tooltipVectorBackBone
export const tooltipIdentifier = (appType) => {
  switch (appType) {
    case "MutationDetection":
      return {
        title: tooltips.contextHelp.identifier.title,
        content: ReactHtmlParser(
          tooltips.contextHelp.identifier.MutationDetection
        ),
      };
      break;
    case "CopyNumberDetermination":
      return {
        title: tooltips.contextHelp.identifier.title,
        content: ReactHtmlParser(
          tooltips.contextHelp.identifier.CopyNumberDetermination
        ),
      };
      break;
    default:
  }
};

// Same tooltip for both assay types
export const tooltipFluorophores = {
  title: tooltips.contextHelp.dyeSelector.title,
  content: ReactHtmlParser(
    tooltips.contextHelp.dyeSelector.additionalDyes.MutationDetection
  ),
};

export const tooltipVectorBackBone = {
  title: tooltips.contextHelp.cellAndGeneTherapy.title,
  content: tooltips.contextHelp.cellAndGeneTherapy.viralVectorBackbone,
};

export const tooltipSequence = (appType) => {
  switch (appType) {
    case "MutationDetection":
      return {
        title: tooltips.contextHelp.sequence.title,
        content: ReactHtmlParser(
          tooltips.contextHelp.sequence.MutationDetection
        ),
      };
      break;
    case "CopyNumberDetermination":
      return {
        title: tooltips.contextHelp.sequence.title,
        content: ReactHtmlParser(
          tooltips.contextHelp.sequence.CopyNumberDetermination
        ),
      };
      break;
    default:
  }
};

export const tubeFormatSelector = {
  title: tooltips.contextHelp.tubeFormatSelector.title,
  content: ReactHtmlParser(
    tooltips.contextHelp.tubeFormatSelector.MutationDetection
  ),
};
//tooltipReferenceGenomeOption

export const tooltipReferenceGenomeOption = {
  title:
    tooltips.contextHelp.genomeEditing.contextSequenceRelationToGenomeTitle,
  content: ReactHtmlParser(
    tooltips.contextHelp.genomeEditing.contextSequenceRelationToGenome
  ),
};

// for match or variation
export const tooltipReferenceGenomeMatchReference = {
  title: tooltips.contextHelp.genomeEditing.matchReferenceGenomeTitle,
  content: ReactHtmlParser(
    tooltips.contextHelp.genomeEditing.matchReferenceGenome
  ),
};

export const tooltipGenomeEditDetectionSpecies = {
  title: "Species",
  content: (
    <ul className="list-unstyled">
      <li>
        Choose background species in which genome editing is being performed.
      </li>
    </ul>
  ),
};

export const tooltipGenomeEditDetectionReferenceGenome = {
  title: "Reference Genome",
  content: (
    <p>
      Choose option 1 if performing genome editing on a wild-type genome.
      <br />
      <br />
      Choose option 2 if performing genome editing on a mutant genome.
      <br />
      <br />
      Mutant genomes include:
      <br />
      1. Genomes with single base pair changes or indels in wild-type genomes
      (for e.g. genome containing deleterious CFTR mutation)
      <br />
      2. Genomes harboring a transgene that is the target for your genome
      editing experiment
      <br />
      <br />
      Note: If a genome contains a transgene, but the region being edited is
      completely outside the transgene, you may choose option 1
    </p>
  ),
};

export const tooltipGenomeEditDetectionHdrContextSequence = {
  title: "Context Sequence",
  content: ReactHtmlParser(
    tooltips.contextHelp.genomeEditing.hdr.contextSequence
  ),
};

export const tooltipGenomeEditDetectionHdrDonorSequence = {
  title: "Donor Sequence",
  content: (
    <ul className="list-unstyled">
      <li>
        Enter the exact sequence of the donor. The sequence should include the
        left and right homology arms that flank the edit region, but no
        sequences beyond the homology arms (e.g. no plasmid backbone).
      </li>
    </ul>
  ),
};

export const tooltipGenomeEditDetectionNhejContextSequence = (
  isMatch,
  isOther
) => {
  let title = "Context Sequence";
  let content = "";
  if (isOther) {
    content = ReactHtmlParser(
      tooltips.contextHelp.genomeEditing.nhej.contextSequenceOther
    );
  }
  if (isMatch) {
    content = ReactHtmlParser(
      tooltips.contextHelp.genomeEditing.nhej.contextSequenceMatch
    );
  }
  if (!isMatch) {
    content = ReactHtmlParser(
      tooltips.contextHelp.genomeEditing.nhej.contextSequenceNoMatch
    );
  }
  return { title: title, content: content };
};

export const tooltipGenomeEditDetectionNhejDonorPresent = {
  title: "Donor Present",
  content: (
    <ul className="list-unstyled">
      <li>
        To measure NHEJ edits in the presence of an HDR donor, the donor
        sequence is required to allow placement of at least one primer outside
        the donor sequence.
      </li>
    </ul>
  ),
};

export const TipAssayBatchUpload = {
  title: "Commercialized Ids",
  content: (
    <ul className="list-unstyled">
      <li>Enter Bio-Rad unique design IDs separated by commas.</li>
      <li>Maximum of 30 assays can be added per submission.</li>
    </ul>
  ),
};
